import { pages } from '@/config'

import {
  initRoutesMeta,
  getNavMenuConfig,
  downToUpReduceMetaAuthority,
} from '@/utils/router'

const HomeLayout = () => import(/* webpackChunkName: "home" */ '@/layout/HomeLayout.vue')
const ProductMonitor = () => import(/* webpackChunkName: "ProductMonitor" */ '@/views/ProductMonitor')
const ProductMonitorOverview = () => import(/* webpackChunkName: "ProductMonitorOverview" */ '@/views/ProductMonitorOverview')
const RoadPropertyMana = () => import(/* webpackChunkName: "RoadPropertyMana" */ '@/views/RoadPropertyMana')
const ElectromechanicalMaintenance = () => import(/* webpackChunkName: "ElectromechanicalMaintenance" */ '@/views/ElectromechanicalMaintenance')
const ServiceArea = () => import(/* webpackChunkName: "ServiceArea" */ '@/views/ServiceArea')
const RoadNetworkSituationAwareness = () => import(/* webpackChunkName: "RoadNetworkSituationAwareness" */ '@/views/RoadNetworkSituationAwareness')
const VehicleIdentification = () => import(/* webpackChunkName: "VehicleIdentification" */ '@/views/VehicleIdentification')
const GuardrailCollision = () => import(/* webpackChunkName: "GuardrailCollision" */ '@/views/GuardrailCollision')

const MaintenanceService = () => import(/* webpackChunkName: "MaintenanceService" */ '@/views/MaintenanceService')

const LoginPage = () => import(/* webpackChunkName: "login" */ '@/views/LoginPage')

const NoFind = () => import(/* webpackChunkName: "404" */ '@/views/Exception/404.vue')
const NoPermission = () => import(/* webpackChunkName: "403" */ '@/views/Exception/403.vue')
const HardwareOperation = () => import(/* webpackChunkName: "HardwareOperation" */ '@/views/HardwareOperation')

const routes = [
  {
    path: '',
    redirect: '/',
    component: HomeLayout,
    meta: { hideInMenu: true },
    children: [
      {
        path: '/',
        redirect: '/productMonitorOverview',
        name: pages.home.name,
        component: ProductMonitor,
        children: [
          {
            path: 'productMonitorOverview',
            name: 'productMonitorOverview',
            component: ProductMonitorOverview,
            meta: {
              name: '总览',
              title: '总览',
              authority: true,
            },
          },
          {
            path: 'maintenanceService',
            name: 'maintenanceService',
            component: MaintenanceService,
            meta: {
              name: '运维监测',
              title: '运维监测',
              authority: true,
            },
          },
          {
            path: 'roadPropertyMana',
            name: 'roadPropertyMana',
            component: RoadPropertyMana,
            meta: {
              name: '路产管理平台',
              title: '路产管理平台',
              authority: true,
            },
          },
          {
            path: 'electromechanicalMaintenance',
            name: 'electromechanicalMaintenance',
            component: ElectromechanicalMaintenance,
            meta: {
              name: '机电运维平台',
              title: '机电运维平台',
              authority: true,
            },
          },
          {
            path: 'serviceArea',
            name: 'serviceArea',
            component: ServiceArea,
            meta: {
              name: '智慧服务区',
              title: '智慧服务区',
              authority: true,
            },
          },
          {
            path: 'roadNetworkSituationAwareness',
            name: 'roadNetworkSituationAwareness',
            component: RoadNetworkSituationAwareness,
            meta: {
              name: '路网态势感知平台',
              title: '路网态势感知平台',
              authority: true,
            },
          },
          {
            path: 'vehicleIdentification',
            name: 'vehicleIdentification',
            component: VehicleIdentification,
            meta: {
              name: '车型识别一体机',
              title: '车型识别一体机',
              authority: true,
            },
          },
          {
            path: 'guardrailCollision',
            name: 'guardrailCollision',
            component: GuardrailCollision,
            meta: {
              name: '护栏碰撞预警系统',
              title: '护栏碰撞预警系统',
              authority: true,
            },
          },
          {
            path: 'HardwareOperation',
            name: 'HardwareOperation',
            component: HardwareOperation,
            meta: {
              name: '非现场执法运维平台',
              title: '非现场执法运维平台',
              authority: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: pages.login.path,
    name: pages.login.name,
    component: LoginPage,
    meta: {
      title: '登录页面',
      hideInMenu: true,
    },
  },
  {
    path: '/',
    redirect: pages.home.path,
    meta: { hideInMenu: true },
  },
  {
    path: '/403',
    component: NoPermission,
    meta: { hideInMenu: true, title: '你没有权限访问该页面' },
  },
  {
    path: '*',
    component: NoFind,
    meta: { hideInMenu: true, title: '没有找到你要去的页面' },
  },
]

const reduceRoute = downToUpReduceMetaAuthority(initRoutesMeta(routes))

export const navMenuConfig = getNavMenuConfig(reduceRoute)

export default reduceRoute
